<div class="card p-3 h-100">
	<div class="dashboard-metric m-auto">
		<div class="title">
			{{ input.title }}
		</div>
		<ngx-gauge
		[value]="input.value"
		[min]="input.minValue"
		[max]="input.maxValue"
		[label]="input.subTitle"
		[append]="input.rateLabel"
		[thick]="10"
		[cap]="'round'"
		[foregroundColor]="'#0048b4'"
		[backgroundColor]="'#eceef0'">
		</ngx-gauge>
	</div>
</div>
